import React, { useEffect, useState } from 'react'
//import XMLViewer from 'react-xml-viewer'
import './carmStatus.scss'
// import { JSONDisplayer } from '../components/util'
import ToggleInvoices from './toggleInvoices'
import StatusDetailItemTitle from './statusDetailItemTitle'
import { getCarmTransactionsById } from '../../../../apiCalls/jobInfo'
import { JSONDisplayer } from './utils'
// import { getTransactionByRequestId, getTransactionByResponseId } from '../commonApis'



const StatusDetailItem = ({responseJson, setResponseJson, enableRawXml, item, index, translate}) => {
    const [isExpanded, setIsExapnded] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    let newResponseJson = {...responseJson };
    const expandedToggle = () => setIsExapnded(!isExpanded) 

    useEffect(() => {
        if(index === 0){ 
            !isExpanded && expandedToggle() 
        }
    }, [])


    const getTransactionById = async () => {
        let response = await getCarmTransactionsById({responseId: item.id, responseFormat: "JSON"})
        newResponseJson[item.id] = {
            "responsePayload": JSON.parse(response.data.eventMessage.responseJsonString)
        }
        setResponseJson(newResponseJson);
    }
    useEffect(() => {
        if (isExpanded) {
            setIsLoading(true)
            getTransactionById()
            // if (item.transactionType === "request") {
            //     getTransactionByRequestId(window.shipmentCountry, item.id).then((res) => {
            //         newResponseJson[item.id] = {
            //             "responsePayload": JSON.parse(res.data.eventMessage.payload)
            //         }
            //         setResponseJson(newResponseJson);
            //     });
            // } else {
            //     getTransactionByResponseId(window.shipmentCountry, item.id).then((response) => {
            //         newResponseJson[item.id] = {
            //             "responsePayload": JSON.parse(response.data.eventMessage.responseJsonString)
            //         }
            //         setResponseJson(newResponseJson);
            //         setIsLoading(false)
            //     })
            // }
        }
    }, [isExpanded])
    
    return ( 
        <div style={{paddingBottom:"3px", "backgroundColor": (index+1)%2==0 ? "rgb(238 244 251)": "#fff"}}>
            <ToggleInvoices
                onClick={expandedToggle}
                titleAlwaysShow={true}
                isActive={isExpanded}
                showDeleteIcon={false}
                activeIcon={"chevron up"}
                inactiveIcon={"chevron down"}
                iconClass="statusDetailIcon circular"
                stepNumberClass="statusDetail"
                titleValueContainer="titleValueStatusDetail"
                titleWidthClass="width0"
                titleValue={
                    <StatusDetailItemTitle 
                        enableRawXml={enableRawXml} 
                        item={item} 
                        index={index} 
                        translate={translate} 
                    />
                }
            />
                {
                    isExpanded && <div style={{paddingLeft: "30px"}}>
                    {
                        responseJson[item.id]?.responsePayload ? (
                            responseJson[item.id]?.responsePayload?.errors
                                ? JSONDisplayer(responseJson[item.id]['responsePayload'], false)
                                : (responseJson[item.id]['responsePayload']?.payload
                                    ? (responseJson[item.id]['responsePayload']?.payload &&
                                        responseJson[item.id]['responsePayload']?.comments) ?
                                        JSONDisplayer({comments:responseJson[item.id]['responsePayload']?.comments,...responseJson[item.id]['responsePayload']?.payload})
                                        : JSONDisplayer(responseJson[item.id]['responsePayload']?.payload)
                                    : JSONDisplayer(responseJson[item.id]['responsePayload'])
                                )
                        )
                            : <div style={{ "margin": "20px", "textAlign": "center" }}>Please wait...</div>
                    }
                   <hr />
            </div>
            }
        </div>
     );
}
export default StatusDetailItem;